export default __webpack_public_path__ + "static/media/6c837504da58a177.e07bde4908bd0704ec38fdcfa7cde7d6.svg";